import { render } from "./KontaktPage.vue?vue&type=template&id=45b319e7&scoped=true"
import script from "./KontaktPage.vue?vue&type=script&lang=js"
export * from "./KontaktPage.vue?vue&type=script&lang=js"

import "./KontaktPage.vue?vue&type=style&index=0&id=45b319e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b319e7"]])

export default __exports__